import styled from 'styled-components/';
import Popover from '@mui/material/Popover';
import Button from '@mui/material/Button';
import AppCSS from '../../../utils/styled';
import { ProjectCalendarPickerVariant } from './index';
import { LARGE_PICKER_WIDTH } from '../../../utils/styled/dimensions';

export const Components = {
  Container: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${LARGE_PICKER_WIDTH}px;
    min-width: ${LARGE_PICKER_WIDTH}px;
  `,
  Picker: styled(Button)<{ pickerVariant: ProjectCalendarPickerVariant }>`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 16px;
    ${AppCSS.radiuses.default};
    text-transform: none !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${({ pickerVariant }) => {
      switch (pickerVariant) {
        case 'white':
          return `
            ${AppCSS.fonts.label14Regular};
            background-color: ${AppCSS.colors.white};
            max-height: ${48}px;
            border: 1px solid ${AppCSS.colors.blues.veryLight};
            &:hover {
              background-color: ${AppCSS.colors.white};
            }
          `;
        case 'whiteSmall':
          return `
            ${AppCSS.fonts.label14Regular};
            background-color: ${AppCSS.colors.white};
            max-height: ${40}px;
            border: 1px solid ${AppCSS.colors.blues.veryLight};
            &:hover {
              background-color: ${AppCSS.colors.white};
            }
          `;
        case 'whiteNoBorders':
          return `
            ${AppCSS.fonts.label14Medium};
            background-color: ${AppCSS.colors.white};
            max-height: ${40}px;
            &:hover {
              background-color: ${AppCSS.colors.white};
            }
          `;
        case 'gray':
          return `
            ${AppCSS.fonts.label14Regular};
            background-color: ${AppCSS.colors.utility.table.headerBackground};
            max-height: ${48}px;
            &:hover {
              background-color: ${AppCSS.colors.utility.table.headerBackground};
            }
          `;
        case 'grayVerySmall':
          return `
            ${AppCSS.fonts.label12Regular};
            background-color: ${AppCSS.colors.utility.table.headerBackground};
            max-height: ${32}px;
            ${AppCSS.radiuses.small};
            &:hover {
              background-color: ${AppCSS.colors.utility.table.headerBackground};
            }
          `;
      }
    }};
  `,
  PickerPlaceholder: styled.span`
    color: ${AppCSS.colors.greys.prettyDark};
  `,
  PickerValue: styled.span`
    color: ${AppCSS.colors.black};
  `,
  PickerIconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  `,
  Popover: styled(Popover)`
    & .MuiPaper-root {
      ${AppCSS.radiuses.default};
      ${AppCSS.boxShadows.menu};
    }
  `,
  PopoverContent: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 8px;
    flex-direction: column;
    gap: 8px;
  `,
  Separator: styled.div`
    width: 100%;
    height: 1px;
    background-color: ${AppCSS.colors.greys.light};
  `,
};
